import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
  Tooltip,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as Excel from "exceljs";
/*import './App.css';*/
/*import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'*/
import { Multiselect } from "multiselect-react-dropdown";

import MultiSelectReact from "multi-select-react";
/*import Multiselect from 'multiselect-dropdown-react';
 */ import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import MySelect from "../../../../shared/components/form/MySelect";
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const options = [];
const optionsUser = [];
var bin_array = [];
var rfqCheckedAll = {};
var zone_arr = [];
var aisles_arr = [];
var racks_arr = [];
var racks_aisle = [];

var options2 = [];

const options1 = [];

const data = [
  {
    name: "one",
    value: "one",
  },
  {
    name: "two",
    value: "two",
  },
  {
    name: "three",
    value: "three",
  },
  {
    name: "four",
    value: "four",
  },
  {
    name: "five",
    value: "five",
  },
  {
    name: "six",
    value: "six",
  },
];



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    

    this.state = {
      showPassword: false,
      invoiceData:[],
      options2: [],
      options1: [],
      loadingGRNData: false,
       tooltipOpen: false,
      approveLoading: false,
      rejectLoading: false,
      totalValue: null,
      totalQty: null,
      cycleCountCancelModal: false,
      selected_batch: "",
      batch_approval_err: false,
      selectedLocationsVal: "",
      location_list: [],
      SelectedBins: [],
      genloading: false,
      selectedOptionRadio: "",
      loadBinData: false,
      schemas: [],
      showFetchGRNData: false,
      successModal: false,
      loadingprintbtn: false,
      modalAssignUser: false,
      zoneDataVal: [],
      removeSelectedDate: false,
      modalCancel: false,
      isChecked: false,
      showFailedItem: false,
      isCheckedData: {},
      FailedItems: [],
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      failedMessage: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      messageModalCycle: false,
      modalReport: false,
      disabledSubmitBtn: false,
      modalfailedCycle: false,
      showDashboardData: true,
      showRack: false,
      showZone: false,
    showProcess:false,
    onSelectProcess:"",
      showAisle: false,
      showBinTable: false,
      modalfailed: false,
      checkedAll: false,
      rfqCheckedAll: {},
      rfqChecked: {},
      postsGRN: [],
      postsProduct: [],
      multiSelect: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsProduct: [],
      ErrorRowData: [],
      binData: [],
      options: [],
      newArrayData: [],
      newArrayData1: [],
      totalScanCount: "",
      selectedUser: {},
      showAssignButton: true,
      showPrintButton: false,
      showSubmitBtn: false,
      clearData: false,
      showSelectedBin: false,
      optionSelected: null,
      optionSelected1: null,
      optionSelected2: null,
      isdisableAssignBtn: true,
    isdisableBinAssignBtn: false,
      optionForBinAddressDropdown: [],
      showBinAddressDropdown: false,
      value: "0",
      selectedBinAddress: "",
      all_binaddress: [],
      dropdownInProgress: false,
      containerOnKeyDown: false,
    loading_overlay: false,
    };
  }

  

  
 

 generatePDF = (data, batchId) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  doc.setFontSize(12);
  doc.setTextColor(0); // Set text color to black
  doc.text(`Batch ID: ${batchId}` , 10, 15); // Position the text at (10, 15)


 const headers = ['Prod Code', 'Prod Name', 'Mrp', 'Value', 'From Bin', 'To Location', 'Qty', 'Reason from WH'];

  const rows = data.map(item => [
    item.prod_code,
    item.prod_name,
    item.mrp,
    item.value,
    item.from_bin,
    item.to_location,
    item.qty,
    item.reason_from_wh
  ]);

  console.log('rows', JSON.stringify(rows))

  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 20,
    theme: 'striped',
    margin: { horizontal: 10 },
    columnStyles: {
      0: { cellWidth: 'auto' },
      1: { cellWidth: 'auto' },
      2: { cellWidth: 'auto' },
      3: { cellWidth: 'auto' },
      4: { cellWidth: 'auto' }
    },
    headStyles: {
      fillColor: [251, 187, 0], // Yellow color in RGB format
      textColor: 0, // Text color (black)
      fontSize: 10,
      cellPadding: 2
    },
    styles: {
      textColor: 0,
      fontSize: 9,
      cellPadding: 1
    },
    pageBreak: 'auto'
  });

  doc.save('stock_movementapproval_data.pdf');
};



 
  
  
 


  
  failedToggleCancelCycle = () => {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }


  componentDidMount(){
    this.fetchCycleCountDashboard();
  }

   toggleTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

 

  
    
  componentWillMount() {
   

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  

  accessCookie =(cookieName) =>{
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie =(cname) =>{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  messagetoggle = () => {
    this.setState({
      messageModal: true,
    });
  }



getLocationList = () => {
    
    const payload = {
      location: this.state.selectedLocation,
    };

  API.post('/cycle_count/fetchCCLocations', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
    
        this.setState({ location_list: data });
      })

      .then(async () => {
        
      });
}

changeRadio = (batch_id)=>{
  this.setState({
    batch_id: batch_id,
    selected_batch: batch_id
  })

}


approveBatch = () => {
    console.log('Batch id',this.state.batch_id)
    
    this.setState({
      approveLoading: true
    })

    if(this.state.selected_batch == "" || this.state.selected_batch == 'undefined'){
      this.setState({
        batch_approval_err: true,
        approveLoading: false
      })
       return false;
    }else{
      this.setState({
        batch_approval_err: false
      })
    }
    
  addAnalytics('Stock Movement Approval', 'Approve Stock Mov');
  API.get('/stock/approveStockMovement?batch_id=' + this.state.batch_id + '&approved=1')

      .then((response) => response.data)

      .then((data) => {
        console.log(data);

        if(data.status == true){
    
       this.setState({
            success_message: data.reason,
            approveLoading: false,
          })
         this.successToggle();

        }else{
          this.setState({
            failedMessage: data.reason,
            approveLoading: false
          })
          this.failedToggle();
        }
      })

      .then(async () => {
        
      });
}

rejectBatch = () => {

     this.setState({
      rejectLoading: true
    })

      if(this.state.selected_batch == "" || this.state.selected_batch == 'undefined'){
      this.setState({
        batch_approval_err: true,
        rejectLoading: false
      })
       return false;
    }else{
      this.setState({
        batch_approval_err: false
      })
    }

    addAnalytics('Stock Movement Approval', 'Reject Stock Mov');

  API.get('/stock/approveStockMovement?batch_id=' + this.state.batch_id + '&approved=2')

      .then((response) => response.data)

      .then((data) => {
    
        if(data.status == true){
          this.setState({
            success_message: data.reason,
            rejectLoading: false
          })
         this.successToggle();

        }else{
          this.setState({
            failedMessage: data.reason,
            rejectLoading: false
          })
          this.failedToggle();
        }
      })

      .then(async () => {
        
      });
}




  

  successToggle = () => {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    //window.location.reload();
  }

   successToggleOK = () => {
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.reload();
  }

  failedToggle = ()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
  }

  

  

    


 

 

   checkedSingle1(index, ischecked,orderid) {
    console.log(index);
    
    var arr=[];
    //console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.postsProduct;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      //data_type = "assign";
      //assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      //data_type = "unassign";
      //unassign_arr.push(orderid);
      
    }

    console.log(newData);
    this.setState({
      tableRowsMap: this.assemblePostsProduct(newData),
      postsProduct: newData
      //binData: newData,
    });

    

    
  }



  changeLocation = (e) => {
    this.setState({
      locationNotSelected: false,
      selectedLocationsVal: e.target.value,
    });
  };


 

  

  fetchCycleCountDashboard = ()=> {
    this.setState({
      genloading: true
    })
    

API.get('/stock/fetchStockAppovalData')

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        //return false;



        if(data.status === false){
          this.setState({
            failedMessage: data.message
          })
          //this.failedToggle();
          //return false;
        }else{

        // if (err) throw err;

           

        this.setState({ invoiceData: data, batch_id: data  });

        console.log(this.state.postsProduct);
      }
      })

      .then(async () => {
        this.setState({
          
          //tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  checkAll1 = () => {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        //showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.postsProduct.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assemblePostsProduct(newData),
        postsProduct: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,

      });

      let newData = this.state.postsProduct.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assemblePostsProduct(newData),
        postsProduct: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }

  onQtyChange = (evt, task_id)=>{


       API.get('/stock/edit-stockmovement-approval?task_id=' + task_id + '&quantity='+ evt.target.value)

      .then((response) => response.data)

      .then((data) => {
        console.log('QTY Change',data);

       /* if(data.status == true){
    
       this.setState({
            success_message: data.reason,
            approveLoading: false,
          })
         this.successToggle();

        }else{
          this.setState({
            failedMessage: data.reason,
            approveLoading: false
          })
          this.failedToggle();
        }*/
      })

      .then(async () => {
        
      });


  }

  
  assemblePostsProduct = () => {
    console.log("cvbn");

    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post, index) => {
      return {
        //action: <input style={{textAlign: 'center'}} className= "table_td_checkbox" type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle1(index,post.isChecked, post.id)}/>,
        prod_code: post.prod_code,
        product_name: post.prod_name,
        mrp: post.mrp,
        value: post.value,
        qty: post.qty,
        reason: post.reason_from_wh,
        //comment:<textarea id="w3review" name="w3review" rows="3" cols="5"/>,
        //status: post.approved === 0 ? <span> Approval Pending </span> : post.approved === 1 ? <span> Approved </span> : <span> Approval Rejected </span>,


      };
    });

    this.setState({
      genloading: false
    })

    return postsProduct;
  };

  

  
 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const {
      showPassword,
      newArrayData,
      newArrayData1,
      selectedUser,
      modalReport,
    } = this.state;
    const { modal, modalCancel } = this.state;
    const { modalAssignUser, modalAssignUserCycleCount } = this.state;
    const {
      messageModal,
      modalfailed,
      successModal,
      modalfailedCycle,
      messageModalCycle,
      cycleCountCancelModal,
    } = this.state;
    const uniqueZoneData1 = {};
    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.zone_id]) {
        uniqueZoneData[item.zone_id] = {
          zoneId: item.zone_no,
          zoneName: item.zone_code,
          id: item.zone_id,
          items: [],
        };
      }
      uniqueZoneData[item.zone_id].items.push(item);
    });

    newArrayData1.map((item) => {
      if (!uniqueZoneData1[item.zone_id]) {
        uniqueZoneData1[item.zone_id] = {
          zoneId: item.zone_id,
          zoneName: item.zone__zone_code,
          items: [],
        };
      }
      uniqueZoneData1[item.zone_id].items.push(item);
    });

    console.log(uniqueZoneData1);
    console.log(uniqueZoneData);
    console.log(this.state.binData);
    console.log(this.state.zoneDataVal);
    console.log(this.state.zoneDataVal.length);

    const productData = {
      columns: [
       /* {
          label: <input class="header_checkbox" type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll1()} />,

          field: "action",
          width: 50,
        },*/
    {
          label: "Prod Code",

          field: "prod_code",

          width: 130,
        },
        {
          label: "Prod Name",

          field: "product_name",

          width: 180,
        },

        {
          label: "Mrp",

          field: "mrp",

          width: 100,
        },


        {
          label: "Value (Mrp)",

          field: "value",
          width: 100,
        },

        {
          label: "Qty",

          field: "qty",
          width: 150,
        },

        {
          label: "Reason from Wh",

          field: "reason",

          width: 150,
        },

       /* {
          label: "Comment",

          field: "comment",

          width: 160,
        },
*/
        


        
      ],

      rows: this.state.tableRowsProduct,
    };

    const GRNData = {
      columns: [
        /* {

          label:'GRN Number',

          field:'grnNumber',

        },

        {

          label:'GRN Line Number',

          field:'gnrLineNumber',

        },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/
        {
          label: "S No.",

          field: "serial",
          width: 180,
        },

        {
          label: "Action",

          field: "status",
          width: 180,
        },

        {
          label: "BIN Id",

          field: "binId",
          width: 180,
        },

        {
          label: "Zone Name",

          field: "zone_name",
          width: 180,
        },

        {
          label: "Zone Id",

          field: "zone_id",
          width: 180,
        },

        {
          label: "LB SKU ID",

          field: "lbskuid",
          width: 180,
        },

        {
          label: "Batch",

          field: "batch",
          width: 180,
        },

        {
          label: "MRP",

          field: "mrp",
          width: 180,
        },

        {
          label: "ICLD Quantity (Box)",

          field: "receivedIcldQuantity",
          width: 180,
        },

        {
          label: "Tester Quantity (pcs)",

          field: "testerQuantity",
          width: 180,
        },

        {
          label: "Loose Quantity (pcs)",

          field: "looseQuantity",
          width: 180,
        },

        {
          label: "STN Date",

          field: "stnDate",
          width: 180,
        },

        {
          label: "STN Number",

          field: "stnNumber",
          width: 180,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 180,
        },

        {
          label: "UPC",

          field: "upc",
          width: 180,
        },

        {
          label: "Total Quantity (pcs)",

          field: "total_quantity",
          width: 180,
        },

        /*{

          label:'GRN Date Time',

          field:'grnDateTime',

        },*/

        /*{

          label:'Base Pack Desc',

          field:'basePackDesc',

        },*/

        {
          label: "Fast Moving",

          field: "fastMoving",
          width: 180,
        },

        {
          label: "Crate Id",

          field: "crateId",
          width: 180,
        },
      ],

      rows: this.state.tableRowsGRN,
    };

    const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
    };
    const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
    };

    return (
      <Col xl={12}>
    {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody style={{height: 80, display: 'none'}}>
            <form className="form form--inline" onSubmit={handleSubmit}>
              

              <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px",}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                    <select
                    className="form-control select_style"
                    style={{ fontSize: 13, width: 310 , marginRight: 20}}
                    onChange={this.changeLocation}
                  
                  >
                    <option value="">Select STN Number</option>
                    {this.state.location_list &&
                      this.state.location_list.length > 0 &&
                      this.state.location_list.map((location_list) => {
                        return (
                          <option value={location_list.id}>
                            {" "}
                            {location_list.code}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>


              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex" }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30 }}
                  >
                    <button
                      color="primary"
                      className="btn-sm button_enable "
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                      }}
                      id="button_enable"
                      onClick={this.fetchCycleCountDashboard}
                    >
                      {this.state.genloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Submit
                    </button>
                  </ButtonToolbar>
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>
          </CardBody>

          {this.state.showDashboardData && (
            <CardBody style={{ marginTop: 20 }}>

             <button className="btn-secondary-success"  style={{marginBottom: 0, color: '#fff', marginTop:5, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold', marginRight: 8}}  onClick={(e) => this.approveBatch()}>  {this.state.approveLoading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )} Approve</button>

                  <button className="btn-secondary-danger" style={{marginBottom: 0, marginTop:5, color: '#fff', paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold',}}  onClick={(e) => this.rejectBatch()}>  {this.state.rejectLoading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}Reject</button>
                {this.state.batch_approval_err &&

                  <div style={{marginTop: 15}}>
                    <span style={{color:'red'}}> *Please select a batch </span>
                  </div>

                }

                  {this.state.invoiceData.length == 0 &&

                  <div style={{marginTop: 15}}>
                    <h5> No Batch Available For Approval </h5>
                  </div>

                }
               
             
                  {this.state.invoiceData.length > 0 &&
               <Accordion id="accordion" allowZeroExpanded={true} style={{ marginTop: 10 }}>
        {this.state.invoiceData.map((item, itemIndex) => (
          <AccordionItem key={item.batch_id} style={{ width: '100%', float: 'left' }}>
            <div style={{ float: 'left', width: '2%', marginRight: 4 }}>
              <input onChange={(e) => this.changeRadio(item.batch_id)} name="prn_val" type="radio" value={item.batch_id} />
            </div>
            <div style={{ float: 'left', width: '95%', marginLeft: 5 }}>
              <AccordionItemHeading style={{width: '280%'}}>
                <AccordionItemButton>
                  {item.cc_batch == "" || item.cc_batch == null &&
                  <span style={{ fontWeight: 'bold' }}>
                    Batch ID: {item.batch_id}  &nbsp;  &nbsp; Type: Stock Movement 
                  </span>
                }

                {item.cc_batch &&
                  <span style={{ fontWeight: 'bold' }}>
                    Batch ID: {item.batch_id}  &nbsp;  &nbsp; Type: CC Batch &nbsp;  &nbsp; CC Batch: {item.cc_batch}
                  </span>
                }

                </AccordionItemButton>
              </AccordionItemHeading>
            </div>
            <AccordionItemPanel style={{width: '275%'}}>
              <div className="dispatchData stock_check_data style_table" style={{ marginTop: 1 }}>
                <div className="inbound_table">
                 <span style={{marginTop: 10}}>
                  <button className="btn-sm show_confirm_button" style={{float: 'right', marginTop: 20, marginBottom: 8}} onClick={() => this.generatePDF(item.approval_data, item.batch_id)}>Download PDF</button>
                  </span>
                  <table>
                    <thead>
                      <tr>
                        <th>Prod Code</th>
                        <th>Prod Name</th>
                        <th>Mrp</th>
                        <th>Value(mrp)</th>
                         <th>From Bin</th>
                         <th>To Location</th>
                        <th>Qty</th>
                       
                        <th>Reason From WH</th>
                         
                      </tr>
                    </thead>
                    <tbody>
                      {item.approval_data.map((insideItem, index) => (
                        <tr key={index}>
                          <td>{insideItem.prod_code}</td>
                          <td>{insideItem.prod_name}</td>
                          <td>{insideItem.mrp}</td>
                          <td>{insideItem.value}</td>
                          <td>{insideItem.from_bin}</td>
                           <td>{insideItem.to_location}</td>
                          <td><input type= "text" defaultValue={insideItem.qty} onChange={(evt) => this.onQtyChange(evt, insideItem.id)} /></td>
                          <td>{insideItem.reason_from_wh}</td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    }
             


                 
              
            </CardBody>
          )}
      
      <div className="row">
            {this.state.showProcess && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showProcess && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Selection Mode
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={[{"label":"Cycle Count by Bin","value":"1"},{"label":"Cycle Count by Area","value":"2"}]}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onSelectProcess}
                          value={this.state.selectedProcess}
                        />
                      </div>
                    </div>
                  )}

                </CardBody>
              </div>
            )}
          </div>
    
      {this.state.showBinAddressDropdown && (
            <div class="row">
              <div className="col-xl-12" style={{marginBottom:20}}>
                <CardBody style={{ marginTop: 20 }}>
                  
                  <div
                    className="form__form-group col-xl-12"
                    style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                  >
                    <span
                      className="form__form-group-label col-xl-3"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                      }}
                    >
                      Bin Address
                    </span>

                    <div
                      className="form__form-group-field col-xl-9"
                      style={{ display: "inline" }}
                    >
                      <input
                        placeholder="Select Bin Address"
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 13,borderColor: 'hsl(0,0%,80%)',borderStyle: 'solid',borderWidth: '1px'
                        }}
                        value={this.state.selectedBinAddress}
                        onChange={this.onBinAddressKeyup}
                        onBlur={this.onBlurBinAddress}
                      />

                      {this.state.containerOnKeyDown && (
                        <div
                          className="suggestions-container"
                          style={{ height: 150, width: "100%" }}
                          ref={(el) => (this.typeahead = el)}
                        >
                          <div className="suggestions">
                            {this.state.optionForBinAddressDropdown.length >
                              0 &&
                              this.state.optionForBinAddressDropdown.map(
                                (item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.onSelectBinAddress([item])
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.label}{" "}
                                  </p>
                                )
                              )}
                          </div>
                        </div>
                      )}

                      
                    </div>
                  </div>
                </CardBody>
              </div>
            </div>
          )}
  
    
          <div className="row">
            {this.state.showZone && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showZone && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Zone
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={options}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal3}
                          allowSelectAll={true}
                          value={this.state.optionSelected}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showAisle && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Aisle{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options1}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal1}
                          allowSelectAll={true}
                          value={this.state.optionSelected1}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showRack && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Rack{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options2}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal2}
                          allowSelectAll={true}
                          value={this.state.optionSelected2}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showSubmitBtn && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            disabled={this.state.disabledBtn}
                            className="btn-sm show_confirm_button"
                            onClick={this.onSubmitCycleCount}
                            type="submit"
                          >
                            {this.state.loadBinData && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Submit
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  )}
                </CardBody>
              </div>
            )}
          </div>
      
          {this.state.showSelectedBin && (
            <CardBody style={{ marginTop: 20 }}>
              <div style={{ width: "100%", marginBottom: 8 }}>
                <span style={{ fontWeight: "bold", fontSize: 15 }}>
                  {" "}
                  Selected Bins ({this.state.SelectedBins.length}){" "}
                </span>
              </div>

              <div style={{ width: "100%" }}>
                {this.state.binData.map(
                  (item, index) =>
                    item.isChecked == true && (
                      <span
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: 13,
                          width: "14%",
                          float: "left",
                          backgroundColor: "#ccc",
                          borderRadius: 6,
                          paddingTop: 4,
                          paddingBottom: 4,
                          marginRight: 8,
                          marginBottom: 5,
                        }}
                      >
                        {" "}
                        {item.bin_address}{" "}<a><i onClick={() => this.removeBin(item.bin_address)}class="fa fa-times" aria-hidden="true" style={{float: 'right', paddingRight: '10px', paddingTop: '4px'}}></i></a>
                      </span>
                    )
                )}
              </div>
        
        {this.state.isdisableBinAssignBtn &&
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex",margin: '20px 0px',paddingLeft: '0px' }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            className="btn-sm show_confirm_button"
                            onClick={this.AssignUser}
                            type="submit"
                          >
                            Assign
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  }
            </CardBody>
          )}

         
          {this.state.showBinTable && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.AssignUser}
                    type="submit"
                    disabled={this.state.isdisableAssignBtn}
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Assign
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={() => this.checkAll()}
                      />{" "}
                    </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.binData.length > 0 &&
                    this.state.binData.map((item, index) => (
                      <tr>
                        <td>
                          {" "}
                          <input
                            type="checkbox"
                            value={item.isChecked}
                            checked={item.isChecked}
                            onChange={() => this.checkedSingle(index, item)}
                          />{" "}
                        </td>
                        <td> {item.bin_address} </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} / </span>{" "}
                  <span style={{ fontWeight: "bold" }}> GRN Line Number: </span>{" "}
                  <span> {this.state.grnLineValue} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  {this.state.showAssignButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.toggle}
                      type="submit"
                    >
                      Assign
                    </Button>
                  )}
                  {this.state.showPrintButton && (
                    <Button color="primary" className="btn-sm" type="submit">
                      Print
                    </Button>
                  )}
                </ButtonToolbar>
              </div>

              <div className="table_val">
                <MDBTable autoWidth striped>
                  <MDBTableHead columns={GRNData.columns} />
                  <MDBTableHead>
                    {this.state.loadingGRNData && (
                      <div
                        style={{
                          width: "2300%",
                          textAlign: "center",
                          paddingTop: 22,
                        }}
                      >
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px", fontSize: 18 }}
                        />
                      </div>
                    )}
                  </MDBTableHead>
                  <MDBTableBody scrollX rows={GRNData.rows} />
                </MDBTable>
              </div>
            </CardBody>
          )}

          {this.state.showFailedItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.confirmData}
                    type="submit"
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Response </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.FailedItems.map((item, index) => (
                    <tr>
                      <td style={{ backgroundColor: "red", color: "#fff" }}>
                        {" "}
                        {item.reason}{" "}
                      </td>

                      <td>{item.bin_address}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modalAssignUser}
          toggle={this.toggleAssignUser}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th>Bin Count</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <Select
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeValStock(selectedOptions, item.id)
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                              className="react-select"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.toggleAssignUser}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {" "}
                Estimated Scan Count :{" "}
                <span style={{ color: "red" }}>
                  {" "}
                  {this.state.totalScanCount}{" "}
                </span>{" "}
              </span>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th> Bin Count </th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData1).length > 0 &&
                  _.map(uniqueZoneData1, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div
                          className="form__form-group"
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className="form__form-group-field"
                          >
                            <MySelect
                              style={{ width: "100%" }}
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(
                                  selectedOptions,
                                  item.zoneId,
                                  item.items
                                )
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.toggleAssignUserCycleCount}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData1}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <form className="form form--inline">
              <div
                className="form__form-group col-xl-10"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{
                    display: "inline",
                    paddingTop: 6,
                    paddingBottom: 6,
                    fontWeight: "bold",
                  }}
                >
                  Select User
                </span>

                <div
                  className="form__form-group-field col-xl-7"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select User"
                    onChange={this.change1}
                    options={[
                      { value: "user1", label: "WMS User" },
                      { value: "test", label: "Test User" },
                    ]}
                  />
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.togglePressCancel}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.toggle}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={cycleCountCancelModal} toggle={this.onCancelCycleModal}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancelCycleModal}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.onCancelCycleModal}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModalCycle} toggle={this.messageToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.messageToggleCycle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.messageToggleCycle}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModalCycle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailed} toggle={this.failedToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.failedToggle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalCancel} toggle={this.cancelToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.cancelToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.cancelReason} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelToggle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalReport}
          toggle={this.toggleReports}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Download Reports
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%" }}>
                <tr>
                  <td>SKU Level and PKM level Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadSKU}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Physical Excess Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadExcessStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Complete Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadCompleteStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style={{ textAlign: "center" }}>
                    <ButtonToolbar
                      className="modal__footer"
                      style={{ paddingTop: 12, paddingBottom: 20 }}
                    >
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.closeReportModal}
                      >
                        Cancel
                      </Button>
                    </ButtonToolbar>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
